import { http } from "../../core/utils/http";
import axios, { Axios } from "axios";
import {
  Register,
  Login,
  ForgotPasswordInit,
  ForgotPasswordComplete,
  ChangePassword,
  ResetPassword,
  Update,
} from "./interface/auth.interface";
import authhHeader from "../../core/utils/authh.header";

class AuthService {
  constructor(private readonly request: Axios) {}
  private createAxiosInstance() {
    return axios.create({
      baseURL: import.meta.env.VITE_BASEURL, 
      headers: authhHeader(), 
    });
  }
  // async register(data: Register): Promise<any> {
  //   return await this.request
  //     .post("/register", { ...data })
  //     .then((res) => {
  //       return res;
  //     })
  //     .catch((err) => {
  //       return err;
  //     });
  // }
  async register(data: Register): Promise<any> {

    const customRequest = this.createAxiosInstance();

    // Log the data being sent
  console.log("Registering with data:", {
    email: data.email,
    password: data.password,
    organisationName: data.company,
  });

    return await customRequest
      .post(
        "/Organisation/Register", 
        {
          email: data.email,
          password: data.password,
          organisationName: data.company,
        },
        {
          headers: authhHeader(),
        }
      )
      .then((res) => {
        console.log("==========",res)
        return res;
      })
      .catch((err) => {
        console.error("Register API error:", err.response?.data || err.message || err);
        return Promise.reject(err.response?.data || err.message || err);
      });      
  }

  async sendEmailConfirmationLink(data: { email: string }): Promise<any> {
    const customRequest = this.createAxiosInstance();
  
    return await customRequest
      .post("/Authentication/send-email-confirmation-link", data, {
        headers: authhHeader(),
      })
      .then((res) => {
        console.log("Email confirmation response:", res);
        return res;
      })
      .catch((err) => {
        console.error("Email confirmation error:", err);
        return err;
      });
  }
  
  // async register(data: Register): Promise<any> {
  //   return await this.request
  //     .post("/register", { ...data })
  //     .then((res) => {
  //       return res;
  //     })
  //     .catch((err) => {
  //       return err;
  //     });
  // }
  // async updateProfile(data: Update): Promise<any> {
  //   return await this.request
  //     .post("/profile", data, { headers: authHeader() })
  //     .then((res) => {
  //       // console.log(res);
  //       return res;
  //     })
  //     .catch((err) => {
  //       // console.log(err);
  //       return err;
  //     });
  // }

  async updateProfile(data: any): Promise<any> {
    const customRequest = this.createAxiosInstance();
    console.log("Update Profile Request:", JSON.stringify(data, null, 2));

    return await customRequest
      .put("/Organisation/Update-Profile", data, {
        headers: {
          ...authhHeader(),
          'Content-Type': 'application/json-patch+json',
        },
      })
      .then((res) => {
        console.log("Update Profile Response:", res);
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  
  // async login(data: Login): Promise<any> {
  //   return await this.request
  //     .post("/login", {
  //       ...data,
  //     })
  //     .then((res) => {
  //       return res;
  //     })
  //     .catch((err) => {
  //       return err;
  //     });
  // }


  async loginn(data: Login): Promise<any> {

    const customRequest = this.createAxiosInstance();

    return await customRequest
      .post("/Authentication/login", 
        {
          email: data.email,
          password: data.password,
        },
        {
          headers: authhHeader(),
        })
      .then((res) => {
        console.log("==========",res)
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async signInWithGoogle(url: string): Promise<any> {
    return await this.request
      .get(url)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async googleLogin(token: string): Promise<any> {
    return await this.request
      .post(`/login/google/${token}`)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async forgotPasswordInit(email: string): Promise<any> {
    const customRequest = this.createAxiosInstance();
    console.log("forget-password request:", {
      email,
    });

    return await customRequest
      .post(`/Authentication/forget-password?Email=${encodeURIComponent(email)}`, null, {
        headers: authhHeader(),
        })
      .then((res) => {
        console.log(
          "forget-password response:",
          res?.data
        );
        return res;
      })
      .catch((err) => {
        console.error(
          "forget-password error:",
          err?.response?.data || err
        );
        return err;
      });
  }

  async changePassword(data: ChangePassword): Promise<any> {
    return await this.request
    .post(`/forgot/verify`, {
      ...data,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
  }
  async changeThePassword(data: {
    newPassword: string;
    currentPassword: string;
  }): Promise<any> {
    const customRequest = this.createAxiosInstance();
  
    return await customRequest
      .put("/Authentication/change-password", data, {
        headers: {
          ...authhHeader(),
          'Content-Type': 'application/json-patch+json',
        },
      })
      .then((res) => {
        console.log("Change Password Response:", res);
        return res;
      })
      .catch((err) => {
        return err.response || err;
      });
  }
  

  async forgotPasswordComplete(data: ForgotPasswordComplete): Promise<any> {
    return await this.request
      .post(`/forgot/complete`, {
        ...data,
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  async resetPassword(data: ResetPassword): Promise<any> {
    const customRequest = this.createAxiosInstance();

    return await customRequest
      .post("/Authentication/reset-password", 
        {
          email: data.email,
          token: data.token,
          newPassword: data.newPassword,
        },
        {
          headers: authhHeader(),
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async confirmEmail(data: { email: string; token: string }): Promise<any> {
    const customRequest = this.createAxiosInstance();

    return await customRequest
      .post("/Authentication/confirm-email", data, {
        headers: authhHeader(),
      })
      .then((res) => {
        console.log("Email confirmation response:", res);
        return res;
      })
      .catch((err) => {
        console.error("Email confirmation error:", err);
        return err;
      });
  }

  async logout(): Promise<any> {
    const customRequest = this.createAxiosInstance();
    return await customRequest
    .put("/Authentication/logout", {}, { 
      headers: authhHeader(), 
    })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  // async registerEmployee(data: { inviteId: string; password: string }): Promise<any> {
  //   try {
  //     const customRequest = this.createAxiosInstance();
  
  //     const response = await customRequest.post(
  //       "/Employee/Register",
  //       {
  //         inviteId: data.inviteId,
  //         password: data.password,
  //       },
  //       {
  //         headers: authhHeader(), // Custom auth header function
  //       }
  //     );
  
  //     console.log("Registration response:", response);
  //     return response;
  
  //   } catch (error: any) {
  //     if (error.response) {
  //       console.error("Registration error (response):", error.response.data);
  //       return Promise.reject(error.response.data);
  //     } else {
  //       console.error("Registration error (message):", error.message);
  //       return Promise.reject(error.message);
  //     }
  //   }
  // }

  async registerEmployee(data: { inviteId: string; password: string }): Promise<any> {
    const customRequest = this.createAxiosInstance();
  
    return await customRequest
      .post(
        "/Employee/Register",
        {
          inviteId: data.inviteId,
          password: data.password,
        },
        {
          headers: authhHeader(),
        }
      )
      .then((res) => {
        console.log("Registration response:", res);
        return res;
      })
      .catch((err) => {
        console.error("Full error response:", err.response?.data);
        // Return the error response data if available, else the whole error object
        return err.response?.data || err;
      });
  }
  
  
  async profile(): Promise<any> {
    return await this.request
      .get("/profile", {
        headers: authhHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
}

export default new AuthService(http);
